import React, { useEffect, useState, useMemo } from "react"
import { InstrumentTemplate } from "components/templates/top/instrument"
import APIs from "redux/apis"
import { APIResponse } from "redux/apis/types"
import { get } from "lodash"
import { withRouter, WithRouterProps } from "react-router"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

export const Instrument: WithRouterProps<React.FC> = withRouter(
  ({ location }) => {
    const [commodityData, upDateCommodityData] = useState([])
    const loadResistId = useMemo(() => uuid(), [])
    const [refreshFlag, setRefreshFlag] = useState(false)
    const isPageLoading = useSelector(
      (state: { PageLoad: LoadStateType }) => state.PageLoad.load
    )

    const commodityApi = async () => {
      store.dispatch(pageLoadRegist(loadResistId, true))

      const priceList: APIResponse.Res | {} = await APIs.SymbolDetail.PriceList(
        {
          Name: "Top.Commodity",
        }
      )
      const resultList = get(priceList, "ResultList")
      upDateCommodityData(resultList)
      store.dispatch(pageLoadRegist(loadResistId, false))
    }
    useEffect(() => {
      commodityApi()
    }, [])

    //ページ更新
    useEffect(() => {
      if (isPageLoading) commodityApi()
    }, [isPageLoading])

    useEffect(() => {
      if (refreshFlag) {
        commodityApi()
        setRefreshFlag(false)
      }
    }, [refreshFlag])

    return (
      <InstrumentTemplate
        commodityData={commodityData}
        transitionData={get(location.state, "rowData")}
        setRefreshFlag={setRefreshFlag}
      />
    )
  }
)
